module.exports = "<div id=\"calendar-right\">\n    <div class=\"datepicker-here\" data-language='es'></div>\n\n</div>"